/**
 * created by yxy
 *
 */

/**
 * 分类组件
 */
import React, {Component} from 'react';
import UploadWall, {getFileImage} from '../../../components/upload/UploadWall'
import ChunkUpload from '../../../components/upload/ChunkUpload';
import {FILE_TYPE, PIC_TYPE, VIDEO_TYPE, AUDIO_TYPE, ATTCHMENT_TYPE} from '../../../constants';
import PropTypes from "prop-types";
import {FileCountLimiter} from "../../../components/upload/FileCountLimiter";
import {checkFileStatus} from "../../../actions/upload";
import {message} from './Mess'
import BaseComponent from "../../../base/BaseComponent";
import {uploadSetting} from '../components/resourcePool/uploadSetting'
import other from '../components/img/other.png'
import UploadStatus from "./UploadStatus";

const doc = ['doc', 'docx', 'DOC', 'DOCX'];
const xls = ['xls', 'xlsx', 'XLS', 'XLSX'];
const ppt = ['ppt', 'pptx', 'PPT', 'PPTX'];
const pdt = ["pdf", 'PDF'];
const rar = ['rar', 'zip', 'tar', 'gz', '7z', 'bz2', 'cab', 'iso', 'RAR', 'ZIP', 'TAR', 'GZ', '7Z', 'BZ2', 'CAB', 'ISO'];
const txt = ['txt', 'TXT'];



const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default class UpLoad extends BaseComponent {
    // 默认属性
    static defaultProps = {
        fileList: [],
        type: 1,
        updateFileList: () => {
        },
        imgHandleChange: () => {

        },
    };
    // 静态类型分析
    static propTypes = {
        fileList: PropTypes.array.isRequired,//选择文件的数组
        imgHandleChange: PropTypes.func.isRequired,//选择图片
        type: PropTypes.number.isRequired,//选择文件上传文件类型
    };

    constructor(props) {
        super(props);
        this.state = {
            type: '',
            fileList: [],
            status: true,
            accept: '',//上传的类型
            isUpload: true,
            num: 0,
        };
        this.chunkUpload = new ChunkUpload({
            checkFileURL: "/storage/checkFile",
            checkChunkURL: "/storage/checkChunk",
            uploadChunkURL: "/storage/uploadChunk",
            chunkUploadOverURL: "/storage/chunkIsUploadOver",
            mergeChunksURL: "/storage/mergeChunk",
            limiter:this.limiter
        });
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getAccept()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.getAccept()
    }

    handleOk = () => {

    };

    getAccept() {
        let accept;
        switch (this.props.type) {
            case 1:
                accept = "." + [...PIC_TYPE].join(",.");
                break;
            case 2:
                accept = "." + [...AUDIO_TYPE].join(",.");
                // accept = "." + AUDIO_TYPE.join(",.");
                break;
            case 3:
                accept = "." + [...VIDEO_TYPE].join(",.");
                break;
            case 4:
                accept = "." + [...ATTCHMENT_TYPE].join(",.");
                break;
            case 0:
                accept = '';
                break;
        }
        this.setState({accept})
    }

    limiter = (() => {
        let uploadSyncMaxCount = window.sysConfig && window.sysConfig.getValueByKey && window.sysConfig.getValueByKey("upload.sync.max.count", "5");//默认5个并发
        return new FileCountLimiter(parseInt(uploadSyncMaxCount));
    })();

    render() {
        let {accept} = this.state;
        let array = JSON.parse(JSON.stringify(accept)).toLowerCase();
        let arr = array.split(",");
        let newArray = [];
        //打开弹框的时候  过滤掉重复的格式
        arr && arr.length && arr.forEach((item, index) => {
            if (newArray.indexOf(item) > -1) {
            } else {
                newArray.push(item)
            }
        });
        return (

            <div>
                <UploadWall
                    accept={newArray.toString()}
                    multiple={true}
                    showPercent={this.props.showPercent}
                    action="/storage/uploadFile"
                    listType="list"
                    Top={this.props.Top}
                    right={this.props.right}
                    fileList={this.state.fileList}
                    beforeUpload={(file, fileList) => {
                        return this.beforeUpload(file, fileList)
                    }}
                    customRequest={this.chunkUpload.start}
                    icons={["eye", "play", "download"]}
                    onChange={this.imgHandleChange}
                    onPreview={this.handlePreview}
                    uploadBtnName={this.props.uploadBtnName}
                    onPlay={this.handlePreview}
                    showUploadBtn={true}
                    onDownload={(file) => {
                        if (file.path.indexOf("?") === -1) {
                            window.location.href = file.path + "?download=1";
                        } else {
                            window.location.href = file.path + "&download=1";
                        }
                    }}
                    style={{padding: "0px"}}
                >
                </UploadWall>
                {this.renderUploding()}
            </div>
        );
    }

    renderUploding() {
        return(<UploadStatus fileList={this.state.fileList}   cancelUpload={this.cancelUpload} callBack={(fileList)=>{
            this.setState({fileList},()=>{
            })
        }}></UploadStatus>)
    }

    beforeUpload = async (file, fileList) => {
        return new Promise((resolve, reject) => {
            this.checkStatusIsUpload((data) => {
                if (data) {
                    if (file.size === 0) {
                        // this.props.updateFileList(fileList);
                        message.error('空文件不能上传！');
                        reject();
                    }
                    let {accept} = this.state;
                    if (accept === '') {
                        accept = "." + [...FILE_TYPE].join(",.");
                    }
                    let newType = '';
                    let nameList = file.name.split('.');
                    newType = nameList.length > 0 ? nameList[nameList.length - 1] : '';
                    if (accept.indexOf(newType) > -1) {
                       this.addFile(file);
                        resolve(file);
                    } else {
                        // this.props.updateFileList(fileList);
                        message.error('暂不支持该文件类型！');
                        reject();
                    }

                } else {
                    message.error('资源库存储空间不足，无法上传，请联系资源管理员。');
                    reject();
                }
            }, this.props.IsTile ? '' : this.props.id);
        });
    };

    addFile=(file)=>{
        this.request({
            url: "/cm-sites-storage-management/upload/add",
            method: "post",
            body: {

                "name": file.name,
                "size": file.size,
                "uid":file.uid
            },
            contentType: 'json',
            callBack: (data) => {
            }
        });
    };

    cancelUpload = (file, fileList) => {
        this.setState({cancelFile: file});
        this.chunkUpload.cancelUpload(file);

    }

    //选择文件
    imgHandleChange = ({file, fileList}) => {
        fileList && fileList.length && fileList.forEach((item, index) => {

            if (item.status === 'done' || item.originFileObj.cancelUpload) {
                fileList.splice(index, 1)
            }
            // if(item.status ==='error'){
            //     fileList.splice(index, 1)
            //     message.success('上传失败的删除');
            // }
        });

        this.props.callBack(JSON.parse(JSON.stringify(fileList)), false);
        if (file.status === "done") {
            this.state.num++;
            fileList = fileList.map(item => {
                // 取决于需要什么数据填入fileList
                if (item.uid === file.uid) {
                    // console.log("-----------item.uid === file.uid-----------", item.uid, file.uid);
                    if (file.response && file.response.data) {
                        //分片上传是走的自己封装的接口 所以返回值只有data
                        //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                        file.response = {...file.response.data, ...file.response};
                    }
                    item.uid = file.uid;
                    item.ext = file.response && file.response.suffix;
                    item.url = file.response && file.response.path;
                    item.name = file.response && file.response.name || file.name;
                    item.isChunk = true;
                    item.status = file.status;
                    item.md5 = file.response && file.response.md5;
                }
                return item;
            })
            if (file.response && file.response.data) {
                //分片上传是走的自己封装的接口 所以返回值只有data
                //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                file.response = {...file.response.data, ...file.response};
            }
            let path;

            let ext = file.response && file.response.suffix;
         
            if (PIC_TYPE.indexOf(ext) > -1) {
                path = file.response.smallPath
            } else if (VIDEO_TYPE.indexOf(ext) > -1) {
                path = file.response.thumbnailsPlayPath ? file.response.thumbnailsPlayPath : file.response.thumbnailsPath;
            }else if (AUDIO_TYPE.indexOf(ext) > -1) {
                path = window.sysConfigGetValueByKey('icon_audio_path', '/storage/779AFAAAE76972A3332B6D5B4B80AE14')
            } else if(doc.indexOf(ext) > -1 ||xls.indexOf(ext) > -1||ppt.indexOf(ext) > -1||pdt.indexOf(ext) > -1||rar.indexOf(ext) > -1||txt.indexOf(ext) > -1) {
                uploadSetting && uploadSetting.length && uploadSetting.forEach(itemSetting => {
                    if (itemSetting.checkKey.indexOf(ext) > -1) {
                        path = window.sysConfigGetValueByKey(itemSetting.val, '')
                    }
                })
            }else{
                 path = other
            }



            let url, method, parms;
            //检索页面的上传走的接口
            if (this.props.IsTile) {
                url = "/cm-sites-storage-management/storage/uploadResource";
                method = 'get';
                parms = {
                    md5: file.response && file.response.md5,
                    aliasKey: this.props.resourceName,
                    uid:file.uid
                };
            } else {
                url = "/cm-sites-storage-management/zykUpload/uploadFile?";
                method = 'post';
                parms = {
                    icon: path,
                    fid: this.props.id,
                    storageFile: file.response,
                    uid:file.uid
                };
            }
            this.request({
                url: url,
                method: method,
                body: parms,
                contentType: 'json',
                callBack: (data) => {
                    let fileType = '';
                    if(PIC_TYPE.indexOf(file.response?.suffix)>-1) {
                        fileType = 1;
                    }else if(VIDEO_TYPE.indexOf(file.response?.suffix)>-1){
                        fileType = 2;
                    }else if(AUDIO_TYPE.indexOf(file.response?.suffix)>-1){
                        fileType = 3;
                    }else {
                        fileType = 4;
                    }
                    let body = {
                        type:fileType,
                        fileName:file.response?.name,
                        md5:file.response?.md5
                    };
                    this.request({
                        url:'/cm-sites-storage-management/zykStatistics/addUploadRecords',
                        method: 'post',
                        body,
                        contentType: 'json',
                        callBack:(data)=>{

                        }
                    });
                    message.success('上传成功');
                    this.props.callBack(JSON.parse(JSON.stringify(fileList)),true);
                    if(this.state.num === fileList.length){
                        // this.setState({fileList: [],num:0})
                }

                }
            });
        }
        // }
        this.setState({
            fileList: fileList
        })

    };

    checkStatusIsUpload(callback, id) {
        this.request({
            url: "/cm-sites-storage-management/zykUpload/checkUpload?fid=" + id,
            method: "get",
            contentType: 'json',
            callBack: (data) => {
                callback(data)
            }
        });
    }

}
